function dispatchDYcontext (type = 'OTHER', options = {}) {
  window.DY.API('spa', {
    context: {
      lng: I18n.acceptLanguage.replace('-', '_'),
      type,
      ...options
    }
  })
}

function dispatchDYready () {
  dataLayer.push({
    'event': 'dy.ready'
  })
}

function setDYcontext (type = 'OTHER', options = {}) {
  window.DY.recommendationContext = {
    lng: `${I18n.acceptLanguage.replace('-', '_')}`,
    type,
    ...options
  }
}

function clearDYcontext () {
  window.DY.recommendationContext = {}
}

export {
  dispatchDYcontext,
  dispatchDYready,
  setDYcontext,
  clearDYcontext
}
